<template>
  <v-dialog v-model="show" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_new_payout") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col cols="6">
              <date-picker
                v-model="form.date"
                singleDate
                :label="$t('finance_date')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model="form.period"
                :label="$t('finance_period_label')"
                prependInnerIcon="mdi-calendar-range-outline"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <text-field
                v-model.number="form.turnover"
                :label="$t('finance_turnover')"
                type="number"
                kind="money"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="4">
              <text-field
                v-model.number="form.deductions"
                :label="$t('finance_deductions')"
                type="number"
                kind="money"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="4">
              <text-field
                v-model.number="form.net"
                :label="$t('finance_net')"
                type="number"
                kind="money"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <text-field
            v-model="form.method"
            :label="$t('finance_payment_method_label')"
            prependInnerIcon="mdi-credit-card-outline"
            :rules="[rules.required]"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const emptyForm = () => ({
  date: "",
  period: "",
  turnover: 0,
  deductions: 0,
  net: 0,
  method: "",
});

export default {
  name: "PayoutFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        date: this.form.date,
        period: this.form.period,
        turnover: Number(this.form.turnover),
        deductions: Number(this.form.deductions),
        net: Number(this.form.net),
        method: this.form.method,
      });
    },
  },
};
</script>
